import { useQuery } from '@tanstack/react-query';
import { getCropFavorite, ICropFavoriteInfo } from '../../../api/crop-trends/getCropFavorite';
import { AxiosError } from 'axios';
import { useCheckUserLoggedIn } from '../../user/useCheckUserLoggedIn';

export const useGetCropFavorite = () => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<ICropFavoriteInfo[], AxiosError>(['crop-favorite'], getCropFavorite, {
    enabled: isUserLoggedIn,
  });
};
